import { useSearchParams } from "react-router";

export const useSelectedTabFromUrl = ({
  defaultValue,
  paramName,
}: {
  defaultValue: string;
  paramName: string;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get the current tab value from URL search parameters.
  const tabValue = searchParams.get(paramName) ?? defaultValue;

  const setTabValue = (value: string) => {
    if (value !== defaultValue) {
      setSearchParams((prev) => {
        const newSearchParams = new URLSearchParams(prev);
        newSearchParams.set(paramName, value);
        return newSearchParams;
      });
    } else {
      setSearchParams((prev) => {
        const newSearchParams = new URLSearchParams(prev);
        newSearchParams.delete(paramName);
        return newSearchParams;
      });
    }
  };

  return {
    tabValue,
    setTabValue,
  };
};
